import { Validator } from 'jsonschema';
import { traverseTrees } from '@/utils/tree-kit';
import { LayerType } from '@/version-types';
import { VERSION } from '../versions';
import { IServerLayerProps } from './layer';
import version500 from './version-types-schema/version500.json';
import version510 from './version-types-schema/version510.json';
import version520 from './version-types-schema/version520.json';
import version600 from './version-types-schema/version600.json';
import version700 from './version-types-schema/version700.json';
import version710 from './version-types-schema/version710.json';
import version800 from './version-types-schema/version800.json';
import version810 from './version-types-schema/version810.json';
import version820 from './version-types-schema/version820.json';
import version830 from './version-types-schema/version830.json';
import version840 from './version-types-schema/version840.json';
import version850 from './version-types-schema/version850.json';
import version900 from './version-types-schema/version900.json';
import version901 from './version-types-schema/version901.json';
import version1000 from './version-types-schema/version1000.json';
import version1100 from './version-types-schema/version1100.json';
import version1110 from './version-types-schema/version1110.json';
import version1200 from './version-types-schema/version1200.json';
import version1201 from './version-types-schema/version1201.json';
import version1202 from './version-types-schema/version1202.json';
import version1300 from './version-types-schema/version1300.json';
import version1301 from './version-types-schema/version1301.json';
import version1302 from './version-types-schema/version1302.json';
import version1303 from './version-types-schema/version1303.json';
import version1310 from './version-types-schema/version1310.json';
import version1400 from './version-types-schema/version1400.json';
import version1410 from './version-types-schema/version1410.json';
import version1420 from './version-types-schema/version1420.json';
import version1500 from './version-types-schema/version1500.json';
import version1510 from './version-types-schema/version1510.json';
import version1511 from './version-types-schema/version1511.json';
import version1512 from './version-types-schema/version1512.json';
import version1520 from './version-types-schema/version1520.json';
import version1530 from './version-types-schema/version1530.json';
import version1600 from './version-types-schema/version1600.json';
import version1700 from './version-types-schema/version1700.json';
import version1701 from './version-types-schema/version1701.json';
import version1702 from './version-types-schema/version1702.json';
import version1703 from './version-types-schema/version1703.json';
import version1710 from './version-types-schema/version1710.json';
// import version1711 from './version-types-schema/version1711.json';
// import version1712 from './version-types-schema/version1712.json';
import version1800 from './version-types-schema/version1800.json';
import version1801 from './version-types-schema/version1801.json';
import version1802 from './version-types-schema/version1802.json';
import version1810 from './version-types-schema/version1810.json';
import version1811 from './version-types-schema/version1811.json';
import version1820 from './version-types-schema/version1820.json';
import version1821 from './version-types-schema/version1821.json';
import version1822 from './version-types-schema/version1822.json';
import version1823 from './version-types-schema/version1823.json';
import version1840 from './version-types-schema/version1840.json';
import version1850 from './version-types-schema/version1850.json';
import version1860 from './version-types-schema/version1860.json';
import version1870 from './version-types-schema/version1870.json';
import version1900 from './version-types-schema/version1900.json';
import version1910 from './version-types-schema/version1910.json';
import version1911 from './version-types-schema/version1911.json';
import version1920 from './version-types-schema/version1920.json';
import version1930 from './version-types-schema/version1930.json';
import version1940 from './version-types-schema/version1940.json';
import version2000 from './version-types-schema/version2000.json';
import version2001 from './version-types-schema/version2001.json';
import version2002 from './version-types-schema/version2002.json';
import version2003 from './version-types-schema/version2003.json';
import version2004 from './version-types-schema/version2004.json';
import version2010 from './version-types-schema/version2010.json';
import version2011 from './version-types-schema/version2011.json';
import version2020 from './version-types-schema/version2020.json';

const versions = {
    [VERSION['20.2.0']]: version2020,
    [VERSION['20.1.1']]: version2011,
    [VERSION['20.1.0']]: version2010,
    [VERSION['20.0.4']]: version2004,
    [VERSION['20.0.3']]: version2003,
    [VERSION['20.0.2']]: version2002,
    [VERSION['20.0.1']]: version2001,
    [VERSION['20.0.0']]: version2000,
    [VERSION['19.4.0']]: version1940,
    [VERSION['19.3.0']]: version1930,
    [VERSION['19.2.0']]: version1920,
    [VERSION['19.1.1']]: version1911,
    [VERSION['19.1.0']]: version1910,
    [VERSION['19.0.0']]: version1900,
    [VERSION['18.7.0']]: version1870,
    [VERSION['18.6.0']]: version1860,
    [VERSION['18.5.0']]: version1850,
    [VERSION['18.4.0']]: version1840,
    [VERSION['18.2.3']]: version1823,
    [VERSION['18.2.2']]: version1822,
    [VERSION['18.2.1']]: version1821,
    [VERSION['18.2.0']]: version1820,
    [VERSION['18.1.1']]: version1811,
    [VERSION['18.1.0']]: version1810,
    [VERSION['18.0.2']]: version1802,
    [VERSION['18.0.1']]: version1801,
    [VERSION['18.0.0']]: version1800,
    [VERSION['17.1.0']]: version1710,
    [VERSION['17.0.3']]: version1703,
    [VERSION['17.0.2']]: version1702,
    [VERSION['17.0.1']]: version1701,
    [VERSION['17.0.0']]: version1700,
    [VERSION['16.0.0']]: version1600,
    [VERSION['15.3.0']]: version1530,
    [VERSION['15.2.0']]: version1520,
    [VERSION['15.1.2']]: version1512,
    [VERSION['15.1.1']]: version1511,
    [VERSION['15.1.0']]: version1510,
    [VERSION['15.0.0']]: version1500,
    [VERSION['14.2.0']]: version1420,
    [VERSION['14.1.0']]: version1410,
    [VERSION['14.0.0']]: version1400,
    [VERSION['13.1.0']]: version1310,
    [VERSION['13.0.3']]: version1303,
    [VERSION['13.0.2']]: version1302,
    [VERSION['13.0.1']]: version1301,
    [VERSION['13.0.0']]: version1300,
    [VERSION['12.0.2']]: version1202,
    [VERSION['12.0.1']]: version1201,
    [VERSION['12.0.0']]: version1200,
    [VERSION['11.1.0']]: version1110,
    [VERSION['11.0.0']]: version1100,
    [VERSION['10.0.0']]: version1000,
    [VERSION['9.0.1']]: version901,
    [VERSION['9.0.0']]: version900,
    [VERSION['8.5.0']]: version850,
    [VERSION['8.4.0']]: version840,
    [VERSION['8.3.0']]: version830,
    [VERSION['8.2.0']]: version820,
    [VERSION['8.1.0']]: version810,
    [VERSION['8.0.0']]: version800,
    [VERSION['7.1.0']]: version710,
    [VERSION['7.0.0']]: version700,
    [VERSION['6.0.0']]: version600,
    [VERSION['5.2.0']]: version520,
    [VERSION['5.1.0']]: version510,
    [VERSION['5.0.0']]: version500,
};

/**
 * 验证模板数据
 *
 * @param version - 版本号
 * @param layers - 图层列表
 */
export const validateTemplate = (version: VERSION, layers: IServerLayerProps[]) => {
    const validator = new Validator();
    const schema = versions[version];

    // 如果非5.0.0以上的模板就直接判断是正常的， 因为保存后就是5.0.0以上的模板了
    if (!schema) {
        return true;
    }

    validator.addSchema(schema);

    const serverLayerPropsSchema = schema.definitions.IServerLayerProps;
    const serverBgLayerPropsSchema = schema.definitions.IServerBgLayerProps;
    const serverTextLayerPropsSchema = schema.definitions.IServerTextLayerProps;
    const serverImageLayerPropsSchema = schema.definitions.IServerImageLayerProps;
    const serverGroupLayerPropsSchema = schema.definitions.IServerGroupLayerProps;
    const serverWatermarkLayerPropsSchema = schema.definitions.IServerWatermarkLayerProps;
    const serverVectorLayerProps = schema.definitions.IServerVectorLayerProps;
    const serverQrCodeLayerProps = schema.definitions.IServerQrCodeLayerProps;
    const serverTableLayerProps = schema.definitions.IServerTableLayerProps;
    const serverBrushLayerProps = schema.definitions.IServerBrushLayerProps;

    let validate = true;

    traverseTrees(layers, (layer) => {
        let result: any = true;
        let schema = serverLayerPropsSchema;

        if (layer.layerType === LayerType.BACKGROUND_LAYER) {
            schema = serverBgLayerPropsSchema;
        } else if (layer.layerType === LayerType.TEXT_LAYER) {
            schema = serverTextLayerPropsSchema;
        } else if (layer.layerType === LayerType.IMAGE_LAYER) {
            schema = serverImageLayerPropsSchema;
        } else if (layer.layerType === LayerType.GROUP_LAYER) {
            schema = serverGroupLayerPropsSchema;
        } else if (layer.layerType === LayerType.WATERMARK) {
            schema = serverWatermarkLayerPropsSchema;
        } else if (layer.layerType === LayerType.VECTOR_LAYER) {
            schema = serverVectorLayerProps;
        } else if (layer.layerType === LayerType.QR_CODE) {
            schema = serverQrCodeLayerProps;
        } else if (layer.layerType === LayerType.TABLE) {
            schema = serverTableLayerProps;
        } else if (layer.layerType === LayerType.BRUSH_LAYER) {
            schema = serverBrushLayerProps;
        }

        result = validator.validate(layer, schema, {
            // allowUnknownAttributes: true,
        });

        if (!result.valid) {
            validate = false;
            console.log('===', result.errors);
            return result.errors;
        }
    });

    if (!validate) {
        return false;
    }

    console.log('版本验证成功');

    return true;
};
